import React, { Fragment } from 'react'
import { getItemOfSessionStorage } from '../../../services/common/utils';
import { SELECTED_LANG } from '../../../services/common/Constants';

const PayOptionsList = () => {
    const language = getItemOfSessionStorage(SELECTED_LANG);

    return (
        <div>
            {
                [1, 2]?.map((list, index) => {
                    return (
                        <Fragment key={index}>
                            <h6 className="primary_14 mt-5 cat-title shimmerBG shimmer-text-sm w-30" style={{ textAlign: language == 'ar' ? 'right' : 'left', marginBottom: '-6px' }}></h6>

                            {
                                [1, 2]?.map((item, index) => {
                                    return (
                                        <div className="filte-plane mt-4" key={index}>
                                            {/* <input type="radio"
                                            name="options"
                                            id={`index_${index}`}
                                    ></input> */}
                                            <label id={`index_${index}`}
                                                style={{
                                                    alignItems: "center",
                                                    justifyContent: "space-between",
                                                }}

                                                className={`white-bg`}>
                                                <div className='d-flex gap-3 align-items-center'>
                                                    {/* <img src={'https://stgweb.ooredoo.com.kw/assets/portal/images/paymentoption/thumbnail/637877889228036988.png'} alt="" title=""
                                            className=''
                                            /> */}
                                                    <div className='shimmerBG shimmer-h30 mb-0' style={{ width: '40px' }}></div>
                                                    <span className='shimmerBG shimmer-text-xs w-30 mb-0' style={{ fontWeight: 'bold' }}></span>
                                                </div>
                                            </label>
                                        </div>
                                    )
                                })
                            }
                        </Fragment>
                    )
                })
            }
        </div>
    )
}

export default PayOptionsList